import Loader from '@trendmicro/react-loader';
import '@trendmicro/react-loader/dist/react-loader.css';

export default Loader;
